import React, { useRef, useState } from "react";
import { useOrgs, usePlant, useUserDetail, useUserPermissions } from "../../services/hooks";
import { ActionMenu, Button, ConfirmationDialog, DetailCard, Dialog, GenericTable, tCell, toastMessage } from "../utils";
import theme, { buttonClasses } from "../utils/theme";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { debounce, formatDate, isObjectEqual } from "../../services/functions";
import { useDeletePlantMutation } from "../../api/vmsSlice";
import Genericfilter from "../utils/Genericfilter";
import Geofence from "../utils/Geofence";
import { GenericstatsV2 } from "../utils/Genericstats";

const defaultFilter = {
	pagesize: 10,
	page_no: 1,
};

const Plant = () => {
	const { userPermissions, isFetched } = useUserPermissions();
	const { isSuperAdmin } = useUserDetail();
	const filterRef = useRef(defaultFilter);
	const { page_no = 1, pagesize = 10 } = filterRef.current;
	const updateDataRef = useRef(null);
	const navigate = useNavigate();
	let { plants, count, isLoading, getPlantDetails } = usePlant(filterRef.current);
	const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
	const [plantToDelete, setPlantToDelete] = useState(null);
	const [handleDelete] = useDeletePlantMutation();
	const { orgOptions } = useOrgs({}, { skip: !isSuperAdmin });
	const [detail, setDetail] = useState(null);
	const [isOpen, setIsOpen] = useState(false);
	const filterFields = [
		{
			inputType: "textfield",
			id: "plantName",
			name: "plantName",
			type: "text",
			label: "Warehouse Name",
			placeholder: "Warehouse Name",
			readOnly: false,
			error: "",
		},
	];
	if (isSuperAdmin) {
		filterFields.push({
			inputType: "dropdown",
			id: "orgId",
			name: "orgId",
			label: "Organization",
			error: "",
			option: orgOptions,
		});
	}
	let actionHandlers = {};
	if (userPermissions?.updatePlant?.value  || isSuperAdmin) {
		actionHandlers.edit = (id) => {
			updateDataRef.current = plants[id];
			navigate("/plants/edit-plant", { state: { updateData: plants[id] } });
		};
	}
	if (userPermissions?.addPlant?.value  || isSuperAdmin) {
		actionHandlers.duplicate = (id) => {
			navigate("/plants/add-plant", { state: { updateData: plants[id] } });
		};
	}
	if (userPermissions?.deletePlant?.value  || isSuperAdmin) {
		actionHandlers.delete = async (id) => {
			setDeleteConfirmOpen(true);
			setPlantToDelete(plants[id]);
		};
	}
	const handleDetailClose = () => {
		setIsOpen(false);
	};
	const handlePlantView = (e, index) => {
		setDetail(createPlantDetailData(plants[index === undefined ? e : index]));
		setIsOpen(true);
	};
		const createPlantDetailData = (plant) => {
		const result = (
			<>
				<div className="geofence-section">
					<h4 style={{ textAlign: "center", marginBottom: "10px" }}>Warehouse:{plant?.plantName}</h4>
					<Geofence factoryCoordinates={plant?.factoryCoordinates} readOnly={true} noExtraField={true}/>
				</div>
			</>
		);
		return result;
	};
	const handleFilterChange = (_filter) => {
		let filter = { ..._filter };

		filter.page_no = 1;
		filter.pagesize = 10;

		if (!isObjectEqual(filterRef.current, filter)) {
			filterRef.current = { ...filter };
			getPlantDetails(filterRef.current);
		}
	};
	const handleDeleteConfirm = async () => {
		if (!plantToDelete) return;

		const payload = { deleteId: plantToDelete._id };
		const {
			data: { error, message },
		} = await handleDelete(payload);

		toastMessage(!error, message);
		getPlantDetails(filterRef.current);
		setDeleteConfirmOpen(false);
		setPlantToDelete(null);
	};
	const handleDeleteCancel = () => {
		setDeleteConfirmOpen(false);
		setPlantToDelete(null);
	};

	let header = ["S.no", "Warehouse Name", "Address"];
	if (isSuperAdmin) header.push("Organization");
	if (userPermissions?.updatePlant?.value || userPermissions?.addPlant?.value || userPermissions?.deletePlant?.value || isSuperAdmin) {
		header.push("Action");
	}

	const rows =
		plants?.map((d, i) => {
			let row = [];
			row.push(tCell((page_no - 1) * pagesize + i + 1));
			row.push(tCell(d.plantName, theme.themeOrange, "pointer", handlePlantView, i, "plantName"));
			row.push( tCell(d.address))
			if (isSuperAdmin) row.push(tCell(d.orgName));
			if (userPermissions?.updatePlant?.value || userPermissions?.addPlant?.value || userPermissions?.deletePlant?.value || isSuperAdmin) {
				row.push(
					<div style={{ paddingLeft: "0.5rem" }}>
						<ActionMenu id={i} handlers={actionHandlers} />
					</div>
				);
			}

			return row;
		}) || [];

	const onPageChange = (page_no) => {
		filterRef.current = { ...filterRef.current, page_no: page_no + 1 };
		getPlantDetails(filterRef.current);
	};

	const onPageSizeChange = (e) => {
		const { value } = e.target;
		filterRef.current = { ...filterRef.current, pagesize: value, page_no: 1 };
		getPlantDetails(filterRef.current);
	};

	if (isFetched && userPermissions && Object.keys(userPermissions).length && !userPermissions?.getPlants?.value && !isSuperAdmin) return <Navigate to="/not-authorized" replace />;
	return (
		<>
			<div className="cust-row flex-algn-cent" style={{ display: "flex", justifyContent: "space-between" }}>
				<div className="cust-col-5">
					<h1 className="title">Warehouses</h1>
				</div>
				{userPermissions?.addPlant?.value  || isSuperAdmin? (
					<Link className="a_tag_no" to={"/plants/add-plant"}>
						<Button text="Add Warehouse" style={buttonClasses.lynkitOrangeEmpty} />
					</Link>
				) : null}
			</div>
			<hr className="bgg" />
			<GenericstatsV2 statsFor={"warehouse"} />
			<Genericfilter filterFields={filterFields} onFilterChange={debounce((filter) => handleFilterChange(filter), 500)} addOnClear />
			<div className="main_content">
				<GenericTable
					header={header}
					rows={rows}
					pageCount={count}
					pageNo={page_no}
					limit={filterRef.current?.pagesize}
					onPageChange={onPageChange}
					onPageSizeChange={onPageSizeChange}
					isLoading={isLoading}
				/>
				<div id="cpdetails">
					<Dialog
								size="md"
								open={isOpen}
								// handleSubmit={() => (!readyForPrint ? handleEdit() : handlePreview())}
								handleClose={handleDetailClose}
								handleCancel={() => handleCancel()}
								title={"Geofence"}
								noBtn={true}
							>{detail}</Dialog>
					</div>
			</div>
			<ConfirmationDialog open={deleteConfirmOpen} handleClose={handleDeleteCancel} handleSubmit={handleDeleteConfirm} title="Delete Warehouse" submitText="Delete">
				Are you sure you want to delete this Warehouse? This action cannot be undone.
			</ConfirmationDialog>
		</>
	);
};
export default Plant;
